module.exports = __webpack_public_path__ + "img/keyboard-open.089d02fa.svg";